import React, { ReactElement } from 'react'
import { Navigate } from 'react-router-dom'
import { routes } from '../routes'
import { useSelector } from 'react-redux'
import { RootState } from '../../store'
import { WithLoginToken } from '../../hoc/WithLoginToken'
import { Box } from '@mui/material'
import useHubspotTracking from '../../hooks/useHubspotTracking'
import HubspotTracker from '../../hooks/useHubspotTracking'
import LegalFooter from '../../components/global/LegalFooter'

const GuestGuard = ({ children }: { children: ReactElement }) => {
    //get Auth user
    const isAuth = useSelector<RootState>(state => state.user.isAuthenticated)


    if (isAuth) {
        return <Navigate to={routes.DASHBOARD_ROUTES.HOME}></Navigate>
    }
    return (
        <div className='app-bg' >
            <HubspotTracker />
            {children}
            <LegalFooter />
        </div>
    )
}

export default WithLoginToken(GuestGuard)

